import {TagType} from "../../../../components/atoms/tag/tag";
import {AppAccessStatus} from "../../../../shared/enums/appAccessStatus";

/**
 * The model for village metric.
 */
export class VillageMetric {
  title: string;
  description: string;
  appAccessStatus: AppAccessStatus;
  count: number;
  total: number | undefined;
  percentage: number | undefined;
  valueDisplay: string;
  tagType: TagType;

  /**
   * Constructor for village metric.
   *
   * @param title The title of the metric.
   * @param description The description of the metric.
   * @param appAccessStatus The app access status of the metric.
   * @param count The number of residents for the village with this status.
   * @param total The total number of residents for the village.
   */
  constructor(
    title: string,
    description: string,
    appAccessStatus: AppAccessStatus,
    count: number,
    total: number | undefined,
    tagType: TagType
  ) {
    this.title = title;
    this.description = description;
    this.appAccessStatus = appAccessStatus;
    this.count = count;
    this.total = total;
    this.tagType = tagType;

    // Set Numerator
    this.valueDisplay = `${count}`;

    if (total !== undefined) {
      // Set the percentage, if possible
      this.percentage = total === 0 ? 0 : Math.round((count / total) * 100);

      // Add denominator
      this.valueDisplay += `/${this.total}`;
    }
  }
}
